// The form input types, in a CJS module so both the React form inputs
// (client/services/form-service/form-inputs.js, which re-exports `inputTypes` from here) and the
// isomorphic CJS services that have to reason about an input's type can read the same strings.
// Requiring form-inputs.js from a service is not an option: it imports the input components.
const inputTypes = {
    TEXT: "text",
    NUMBER: "number",
    EMAIL: "email",
    SELECT: "select",
    TEXT_AREA: "text_area",
    PHONE: "phone",
    CHECKBOX: "checkbox",
    MULTI_SELECT: "multi_select"
};
// Inputs whose value can only be one of a fixed option list, so the chosen option is safe to report
// to analytics. Everything else is free text the visitor typed (name, email, phone, "tell us more")
// and may be PII — those inputs only ever report a length.
const OPTION_BASED_INPUT_TYPES = [
    inputTypes.SELECT,
    inputTypes.MULTI_SELECT,
    inputTypes.CHECKBOX
];
const isOptionBasedInputType = (type)=>OPTION_BASED_INPUT_TYPES.includes(type);
module.exports = {
    inputTypes,
    OPTION_BASED_INPUT_TYPES,
    isOptionBasedInputType
};
